const resolveApiHost = (): string => {
  const explicitUrl = process.env.REACT_APP_API_URL?.trim();
  if (explicitUrl) {
    return explicitUrl.endsWith("/") ? explicitUrl : `${explicitUrl}/`;
  }

  const host = process.env.REACT_APP_API_HOST?.trim();
  if (host) {
    if (/^https?:\/\//i.test(host)) {
      return host.endsWith("/") ? host : `${host}/`;
    }
    const protocol =
      typeof window !== "undefined" ? window.location.protocol : "http:";
    return `${protocol}//${host.replace(/^\/+|\/+$/g, "")}/`;
  }

  if (process.env.NODE_ENV === "development") {
    return "/evaluacion/";
  }

  throw new Error(
    "Falta REACT_APP_API_URL o REACT_APP_API_HOST en el archivo .env"
  );
};

const API_HOST = resolveApiHost();

// Constantes de headers HTTP (SonarQube: evitar literales duplicados)
export const HEADERS_JSON = { "Content-Type": "application/json" };
export const METHOD_POST  = "POST";
export const METHOD_PUT   = "PUT";
export const METHOD_GET   = "GET";
export const XHR_HEADER   = { "X-Requested-With": "XMLHttpRequest" };

export default API_HOST;